var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoadingLine',{attrs:{"title":"File ảnh đang được cập nhật","count":_vm.taskProgress.progress}})
}
var staticRenderFns = []

export { render, staticRenderFns }